import {
  ActivityDashboard,
  AddEditBilledForPeriod,
  AddEditBillingConfig,
  AddEditBillingLog,
  AddEditCashApp,
  AddEditClearing,
  AddEditInvoice,
  AddEditJournalEntry,
  AddEditLineItem,
  AddEditPayment,
  AddEditPendingPosting,
  AR360Report,
  BilledForPeriodListing,
  BillingConfig,
  BillingLogs,
  CashAppList,
  ClearingListing,
  InvoiceListing,
  JournalEntryList,
  LineItems,
  Payment360InvoiceListing,
  Payment360Report,
  PaymentListing,
  PendingPostingListing,
  DisplayAccountingDocument,
  Reports,
  TrialBalance,
  ToleranceReport,
  FiscalYearClosing,
  FiscalYearLifecycle,
  GLConfigurationStudio,
  AuditTrail,
  AuditTrailView,
  CreateJEManual,
  ParkedPostedJEListing,
  DistributionMetricsMaintenance,
  JEDetails,
  DistributionRuleConfiguration,
  DistributionRunTimeDetails,
  ViewJobDetails,
  ViewJobGlDetails,
  TraceabilityReport,
  FixedWeight,
  WeighingFactorDetailedView,
  WeighingFactor,
  ReconciliationReport,
  ReportByOwner,
  ReportByVendor,
  VendorTrialBalance,
  OwnerTrialBalance,
  CloseoutReport,
  CostTrialBalance,
  ManagerialReport,
} from "@/pages";
import { routes } from "../utils";

export const ActivityDashboardRoutes = () => {
  return {
    path: routes.activityDashboard,
    children: [
      {
        path: "",
        element: <ActivityDashboard />,
      },
      {
        path: routes.invoice + "/" + routes.add,
        element: <AddEditInvoice />,
      },
      {
        path: routes.invoice + "/" + routes.invoiceAction,
        element: <InvoiceListing />,
      },
      {
        path:
          routes.payment +
          "/" +
          routes.paymentAction +
          "/" +
          routes.paymentId +
          "/" +
          routes.action,
        element: <AddEditPayment />,
      },
      {
        path:
          routes.invoice +
          "/" +
          routes.invoiceAction +
          "/" +
          routes.invoiceId +
          "/" +
          routes.action,
        element: <AddEditInvoice />,
      },
      {
        path: routes.payment + "/" + routes.add,
        element: <AddEditPayment />,
      },
      {
        path: routes.payment + "/" + routes.paymentAction,
        element: <PaymentListing />,
      },
      {
        path: routes.payment + "/" + routes.reports,
        children: [
          {
            path: "",
            element: <Payment360Report />,
          },
          {
            path: routes.glId + "/" + routes.month,
            children: [
              {
                path: "",
                element: <Payment360InvoiceListing />,
              },
              {
                path: routes.invoiceId + "/" + routes.action,
                element: <AddEditInvoice />,
              },
            ],
          },
          {
            path:
              routes.glId +
              "/" +
              routes.month +
              "/" +
              routes.listing +
              "/" +
              routes.paymentAction,
            children: [
              {
                path: "",
                element: <PaymentListing />,
              },
              {
                path: routes.paymentId + "/" + routes.action,
                element: <AddEditPayment />,
              },
            ],
          },
        ],
      },
      {
        path: routes.payment + "/" + routes.tolerance,
        children: [
          {
            path: "",
            element: <ToleranceReport />,
          },
          {
            path:
              routes.budgetMgmt +
              "/" +
              routes.budgetId +
              "/" +
              routes.lineItems,
            children: [
              {
                path: "",
                element: <LineItems />,
              },
              {
                path: routes.lineItemId + "/" + routes.action,
                element: <AddEditLineItem />,
              },
            ],
          },
        ],
      },
      {
        path: routes.billingConfig,
        element: <BillingConfig />,
      },
      {
        path: routes.billingConfig + "/" + routes.add,
        element: <AddEditBillingConfig />,
      },
      {
        path:
          routes.billingConfig + "/" + routes.billingId + "/" + routes.action,
        element: <AddEditBillingConfig />,
      },
      {
        path: routes.pendingPosting,
        element: <PendingPostingListing />,
      },
      {
        path:
          routes.pendingPosting + "/" + routes.billingId + "/" + routes.action,
        element: <AddEditPendingPosting />,
      },
      {
        path: routes.billedForPeriod,
        element: <BilledForPeriodListing />,
      },
      {
        path:
          routes.billedForPeriod + "/" + routes.billingId + "/" + routes.action,
        element: <AddEditBilledForPeriod />,
      },
      {
        path: routes.billingLog,
        element: <BillingLogs />,
      },
      {
        path: routes.billingLog + "/" + routes.billingId + "/" + routes.action,
        element: <AddEditBillingLog />,
      },
      {
        path: routes.journalEntry,
        element: <JournalEntryList />,
      },
      {
        path: routes.journalEntry + "/" + routes.action,
        element: <AddEditJournalEntry />,
      },
      {
        path:
          routes.journalEntry + "/" + routes.billingId + "/" + routes.action,
        element: <AddEditJournalEntry />,
      },
      {
        path: routes.invoiceReports,
        element: <Reports />,
      },
      {
        path: routes.clearing,
        children: [
          {
            path: "",
            element: <ClearingListing />,
          },
          {
            path: routes.add,
            element: <AddEditClearing />,
          },
          {
            path: routes.clearingId + "/" + routes.action,
            element: <AddEditClearing />,
          },
        ],
      },
      {
        path: routes.cashApp,
        children: [
          {
            path: "",
            element: <CashAppList />,
          },
          {
            path: routes.add,
            element: <AddEditCashApp />,
          },
          {
            path: routes.id + "/" + routes.status + "/" + routes.action,
            element: <AddEditCashApp />,
          },
        ],
      },
      {
        path: routes.ar360,
        element: <AR360Report />,
      },
      {
        path: routes.fiscalYearClosing,
        element: <FiscalYearClosing />,
      },
      {
        path:  routes.fiscalYearLifeCycle,
        element: <FiscalYearLifecycle />,
      },
      {
        path: routes.trialBalance,
        element: <TrialBalance />,
      },
      {
        path: routes.displayAccountingDocument,
        element: <DisplayAccountingDocument />,
      },
      {
        path: routes.glConfigurationStudio,
        element: <GLConfigurationStudio />,
      },
      {
        path: routes.auditTrail,
        children: [
          {
            path: "",
            element: <AuditTrail />,
          },
          {
            path: routes.id + "/" + routes.action,
            element: <AuditTrailView />,
          },
        ]
      },
      {
        path: routes.createJEManual,
        element: <CreateJEManual />,
      },
      {
        path: routes.jeManual + "/" + routes.status,
        children: [
          {
            path: "",
            element: <ParkedPostedJEListing />,
          },
          {
            path: routes.id + "/" + routes.action,
            element: <JEDetails />,
          },
        ],
      },
      {
        path: routes.distributionMetricsMaintenance,
        children: [
          {
            path: "",
            element: <DistributionMetricsMaintenance />,
          },
          {
            path: routes.weighingFactor + "/" + routes.id + "/" + routes.action,
            element: <WeighingFactorDetailedView />,
          }
        ]
      },
      {
        path: routes.distributionRuntimeDetails,
        children: [
          {
            path: "",
            element: <DistributionRunTimeDetails />,
          },
          {
            path: routes.id,
            element: <ViewJobDetails />,
          },
          {
            path: routes.id + "/" + routes.glId,
            element: <ViewJobGlDetails />,
          },
        ],
      },
      {
        path: routes.distributionRuleConfiguration,
        children: [
          {
            path: "",
            element: <DistributionRuleConfiguration />,
          },
          {
            path: routes.fixedWeight + "/" + routes.level + "/" + routes.type + "/" + routes.action,
            element: <FixedWeight />,
          },
          {
            path: routes.weighingFactor + "/" + routes.type,
            children: [
              {
                path: "",
                element: <WeighingFactor />,
              },
              {
                path: routes.id + "/" + routes.details,
                element: <WeighingFactorDetailedView />,
              }
            ]
          }
        ]
      },
      {
        path: routes.traceability,
        children: [
          {
            path: "",
            element: <TraceabilityReport />,
          },
          {
            path: `${routes.distributionRuleConfiguration}/${routes.glId}`,
            children: [
              {
                path: "",
                element: <DistributionRuleConfiguration />
              },
              {
                path: routes.fixedWeight + "/" + routes.level + "/" + routes.type + "/" + routes.action,
                element: <FixedWeight />,
              },
              {
                path: routes.weighingFactor + "/" + routes.type,
                children: [
                  {
                    path: "",
                    element: <WeighingFactor />,
                  },
                  {
                    path: routes.id + "/" + routes.details,
                    element: <WeighingFactorDetailedView />,
                  }
                ]
              }
            ]
          },
        ]
      },
      {
        path: routes.reconciliation,
        element: <ReconciliationReport />,
      },
      {
        path: routes.closeout,
        element: <CloseoutReport />,
      },
      {
        path: routes.reportByOwner,
        element: <ReportByOwner />,
      },
      {
        path: routes.reportByVendor,
        element: <ReportByVendor />,
      },
      {
        path: routes.vendorTrialBalance,
        element: <VendorTrialBalance />,
      },
      {
        path: routes.ownerTrialBalance,
        element: <OwnerTrialBalance />,
      },
      {
        path: routes.costTrialBalance,
        element: <CostTrialBalance />,
      },
      {
        path: routes.managerialReport,
        element: <ManagerialReport />,
      },
    ],
  };
};
